/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React, { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import { Element, ContentSection, Column } from "trux"
import traceLogo from "../assets/trace-logo.svg"
import { parseQuery } from "../../../util/query"
import { webApi } from "../../../lib/WebApi"
import { useGetUserRelationsQuery } from "../../../generated/graphql"
import {
    addRelation,
    checkForEmail,
    emailSwitch,
    getUserInfo,
    loadUser,
} from "../actions"

export const LoadingStep = (props) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const [logoutStepDone, setLogoutStepDone] = useState(false)
    const [loginStepDone, setLoginStepDone] = useState(false)
    const searchParams = parseQuery(location.search)
    const userId = searchParams ? parseInt(searchParams["user_id"], 10) : null
    const token = searchParams ? parseInt(searchParams["token"], 10) : null

    useEffect(() => {
        console.log("props loggedin", props.isLoggedIn)
        if (props.isLoggedIn >= 0) {
            console.log("running")
            props.logInUser()
        }
    }, [props.isLoggedIn])

    // useEffect(() => {
    //     if (
    //         props.isLoggedIn &&
    //         props.isLoggedIn !== userId &&
    //         !logoutStepDone
    //     ) {
    //         webApi
    //             ._post("/webapp/users/self/logout")
    //             .then(setLogoutStepDone(true))
    //     } else if (props.isLoggedIn === 0) {
    //         setLogoutStepDone(true)
    //     } else if (props.isLoggedIn && props.isLoggedIn === userId) {
    //         setLoginStepDone(true)
    //     }
    // }, [props, logoutStepDone])

    // useEffect(() => {
    //     if (userId && token && logoutStepDone && props.isLoggedIn === 0) {
    //         webApi.loginByCode(userId, token).then((json) => {
    //             dispatch({ type: "COMMON_RESET" })
    //             setLoginStepDone(true)
    //         })
    //     }
    // }, [logoutStepDone])

    // useEffect(() => {
    //     if (loginStepDone && props.isLoggedIn) {
    //         getUserInfo()
    //         //checkForEmail("tabitha@traceup.com")
    //         //addRelation(2835084, [], "tabitha@traceup.com")
    //         // emailSwitch(
    //         //     2835084,
    //         //     { email: "tabithableil+test2@gmail.com" },
    //         //     [],
    //         //     "tabithableil+192023@gmail.com"
    //         // )
    //         props.onDone()
    //     }
    // }, [loginStepDone, props])

    // const { data: userRelations, loading: relationsLoading } =
    //     useGetUserRelationsQuery({
    //         variables: {
    //             to_user_id: props.token?.user_id,
    //             token: props.token,
    //             include_self: true,
    //         },
    //     })
    // const relations = userRelations ? userRelations.userRelations : null

    return (
        <ContentSection>
            <Column center span="12" className="loading">
                <Element tag="img" src={traceLogo} />
            </Column>
        </ContentSection>
    )
}
